import { DateRange } from '@/constants/filters/filters'
import type { AdminMrrResponse, AdminTransactionListResponse, DashboardOrganizationResponse } from '@/types/adminDashboard'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface AdminDashboardState {
  /** Cached organization details by organization ID. Cleared on page refresh. */
  organizationDetailById: Record<string, DashboardOrganizationResponse>,
  mrr?: AdminMrrResponse,
  transactions?: AdminTransactionListResponse,
  transactionsFilterDateRange: DateRange
}

const initialState: AdminDashboardState = {
  organizationDetailById: {},
  mrr: undefined,
  transactions: undefined,
  transactionsFilterDateRange: DateRange.LAST_1_MONTH
}

const setOrganizationDetail = (
  state: AdminDashboardState,
  action: PayloadAction<DashboardOrganizationResponse>
) => {
  return {
    ...state,
    organizationDetailById: {
      ...state.organizationDetailById,
      [action.payload.organizationId]: action.payload
    } 
  }
}

const setMRR = (state: AdminDashboardState, action: PayloadAction<AdminMrrResponse>) => {
  return {
    ...state,
    mrr: action.payload
  }
}

const setTransactions = (state: AdminDashboardState, action: PayloadAction<AdminTransactionListResponse>) => { 
  return {
    ...state,
    transactions: action.payload
  }
}

const setDateRange = (state: AdminDashboardState, action: PayloadAction<DateRange>) => {
  return {
    ...state,
    transactionsFilterDateRange: action.payload
  }
}

const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {
    setOrganizationDetail,
    setMRR,
    setTransactions,
    setDateRange
  }
})

export const adminDashboardReducer = adminDashboardSlice.reducer
export const adminDashboardActions = adminDashboardSlice.actions
